<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title">
                <span>超时未响应工单自动提醒规则</span>
                <el-tooltip popper-class="shadow" effect="light" placement="bottom-start"
                    content="超时未响应工单指某个工单在配置的触发动作后，在规定时间内没有对工单进行响应（修改/回复/转交/完结）">
                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt="">
                </el-tooltip>
            </div>
            <div class="form_box">
                <el-form class="border_style">
                    <p>触发动作后</p><br>
                    <div class="padding_left">
                        <el-form-item label="触发动作：">
                            <el-checkbox-group v-model="roleList.action_list">
                                <el-checkbox label="create_action">创建工单</el-checkbox>
                                <el-checkbox label="forward_action">转交工单</el-checkbox>
                                <el-checkbox label="reply_action">回复工单</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="提醒时间：">
                            <el-form class="time_list">
                                <el-form-item v-for="(item, index) in roleList.action_time" :key="index">
                                    <div class="time_box">
                                        <el-input class="input_box" v-model="item.num" placeholder="输入" maxlength="4"></el-input>
                                        &nbsp;
                                        <el-select v-model="item.time_type" placeholder="请选择">
                                            <el-option label="小时" value="h"></el-option>
                                            <el-option label="分钟" value="m"></el-option>
                                        </el-select>&nbsp;&nbsp;
                                        <div>
                                            <el-button type="text" @click="delActionTimeRole(index)"><i
                                                    class="el-icon-remove icon_color"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </el-form-item>
                                <div :model="newActionTime" v-if="showNewActionTime">
                                    <div class="time_box">
                                        <el-input v-model="newActionTime.num" placeholder="输入" class="input_box"  maxlength="4"
                                            @change="addActionTimeRole">
                                        </el-input>&nbsp;
                                        <el-select v-model="newActionTime.time_type" placeholder="请选择">
                                            <el-option label="小时" value="h"></el-option>
                                            <el-option label="分钟" value="m"></el-option>
                                        </el-select>&nbsp;&nbsp;
                                        <div>
                                            <el-button type="text" @click="showNewActionTime = false"><i
                                                    class="el-icon-remove icon_color"></i></el-button>
                                        </div>
                                    </div>
                                </div>
                                <el-form-item label="">
                                    <el-button class=" btn_bg" type="text" @click="open1()">+添加定时规则
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-form-item>
                    </div>
                </el-form>
                <el-form class="border_style">
                    <p>每天固定时间</p><br>
                    <div class="padding_left">
                        <el-form-item label="提醒时间：">
                            <el-form class="time_list">
                                <el-form-item v-for="(item, index) in roleList.day_time" :key="index">
                                    <div class="time_box">
                                        <!-- <el-input class="input_box" v-model="roleList.day_time" placeholder="请输入">
                                    </el-input> -->
                                        <el-time-select v-model="roleList.day_time[index]" placeholder="选择时间"
                                            :clearable="false" :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00'
                                            }">
                                        </el-time-select>&nbsp;&nbsp;
                                        <div>
                                            <el-button type="text" @click="delDayTimeRole(index)"><i
                                                    class="el-icon-remove icon_color"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </el-form-item>
                                <div v-if="showNewDayTime">
                                    <div class="time_box">
                                        <el-time-select v-model="newDayTime" placeholder="选择" @change="addDayTimeRole"
                                            :clearable="false" :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '23:45'
                                            }">
                                        </el-time-select>&nbsp;&nbsp;
                                        <div>
                                            <el-button type="text" @click="showNewDayTime = false"><i
                                                    class="el-icon-remove icon_color"></i></el-button>
                                        </div>
                                    </div>
                                </div>
                                <el-form-item label="">
                                    <el-button class="btn_bg" type="text" @click="open2()">+添加定时规则
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-form-item>
                    </div>
                </el-form>
                <span class="font-size">启用状态：</span>&nbsp;<el-switch v-model="roleList.is_run" active-color="#507FF7"
                    inactive-color="rgb(204, 204, 204)">
                </el-switch>
                <br><br>
                <div class="button" @click="save" v-if="roleCheck('101-103-102-102')">
                    <span>保存</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default ({
    name: 'remind-roles',
    data() {
        return {
            product: [],
            overviewTime: '',
            roleListData: [],
            total: 0,
            isRun: true,
            newActionTime: {
                num: '',
                time_type: 'm',
            },
            showNewActionTime: false,
            roleList: {
                day_time: [],
                action_list: [],
                action_time: []
            },
            newDayTime: '',
            showNewDayTime: false
        }
    },
    created() {
        this.getRulesList();
    },
    methods: {
        getRulesList() {
            this.api.getRemindRules({}).then(data => {
                this.roleList = data.data.result;
                this.roleList.action_list = this.roleList.action_list || [];
                this.roleList.action_time = this.roleList.action_time || [];
                this.roleList.day_time = this.roleList.day_time || [];
                // console.log(this.roleList.actionList)
            })
        },
        delActionTimeRole(index) {
            this.roleList.action_time.splice(index, 1)
        },
        delDayTimeRole(index) {
            this.roleList.day_time.splice(index, 1)
        },
        addActionTimeRole() {
            if (this.roleList.action_time.length + this.roleList.day_time.length >= 5) {
                this.$message.warning('最多只允许添加5条规则！');
                return;
            }
            if (this.newActionTime.num != '') {
                this.roleList.action_time.push(this.newActionTime)
                this.showNewActionTime = false;
                this.newActionTime = {
                    num: '',
                    time_type: 'm'
                };
            }
        },
        addDayTimeRole() {
            if (this.roleList.action_time.length + this.roleList.day_time.length >= 5) {
                this.$message.warning('最多只允许添加5条规则！');
                return;
            }
            if (this.newDayTime != '') {
                this.roleList.day_time.push(this.newDayTime)
                this.showNewDayTime = false;
                this.newDayTime = '';
            }
        },
        open1() {
            if (this.roleList.action_time.length + this.roleList.day_time.length >= 5) {
                this.$message.warning('最多只允许添加5条规则！');
                return;
            }
            this.showNewActionTime = true
        },
        open2() {
            if (this.roleList.action_time.length + this.roleList.day_time.length >= 5) {
                this.$message.warning('最多只允许添加5条规则！');
                return;
            }
            this.showNewDayTime = true
        },
        save() {
            this.api.addRemindRules(this.roleList).then(data => {
                this.$message.success('操作成功！');
                this.showNewActionTime=false;
                this.showNewDayTime=false;
                // this.getRulesList();
            })
        }
    }
})
</script>

<style lang="less" scoped>
.title {
    .flexLayout(flex-satrt);
}

.form_box {
    width: 600px;
}

.time_box {
    display: flex;
}

.sel_box {
    width: 100px;
}

/deep/ .el-input {
    width: 80px;
}

/deep/ .el-form .el-select {
    width: 80px;
}

/deep/ .el-form .el-input__inner {
    min-width: 80px;
}

.time_list {
    padding-left: 85px;
}

.new_action_time {
    padding-left: 120px;

    .new_box {
        display: inline-flex;

    }
}

.border_style {
    border: 1px solid @colorLine;
    padding: 20px;
    margin: 20px 0;
}

/deep/ .el-form .el-date-editor.el-input {
    height: 34px;
    width: 160px;
    padding: 1px;
}

.btn_bg {
    background-color: #E1EAFF;
    padding: 5px 9px;
}

.font-size {
    font-size: 14px;
}

.padding_left {
    padding-left: 30px;
}

.icon_color {
    color: #EB534B;
}

.input_box {
    padding-bottom: 5px;
}
@media (max-width: 768px) {
    .content{
        border-radius: 12px;
    }
    .form_box{
        width: 100%;
        padding: 0;
    }
    .border_style{
        padding: 10px;
    }
    .padding_left{
        padding-left: 0;
        font-size: 12px;
    }
    /deep/.el-checkbox{
        margin-right: 10px;
        .el-checkbox__label{
            font-size: 12px;
        }
    }
    /deep/.el-form-item__label{
        padding: 0;
        font-size: 12px;
    }
    /deep/ .el-form{
        .el-date-editor.el-input{
            height: 28px;
            .el-input__inner{
                padding-left: 30px;
            }
        }
        
    }
}
</style>


// WEBPACK FOOTER //
// src/view/order/order-settings/remind-roles.vue